import type { PhoneNumberResource, UserResource } from '@clerk/types'

import { isNonEmptyString } from './type-checkers'


export function hasRequiredName(user?: Pick<UserResource, 'firstName' | 'lastName'> | null): boolean {
    return isNonEmptyString(user?.firstName) && isNonEmptyString(user?.lastName)
}

export function getVerifiedPhoneNumber(user?: Pick<UserResource, 'phoneNumbers'> | null): PhoneNumberResource | undefined {
    return user?.phoneNumbers.find(({ verification }) => verification.status === 'verified')
}

export function getPendingPhoneNumber(user?: Pick<UserResource, 'phoneNumbers'> | null): PhoneNumberResource | undefined {
    return user?.phoneNumbers.find(({ verification }) => verification.status !== 'verified')
}

export function normalizeSearch(search = ''): string {
    if (!search) return ''
    return search.startsWith('?') ? search : `?${search}`
}

export function getRequiredOnboardingPath(user?: Pick<UserResource, 'firstName' | 'lastName' | 'phoneNumbers'> | null, search = ''): string | null {
    const normalizedSearch = normalizeSearch(search)

    if (!hasRequiredName(user)) return `/sign-up/add-info${normalizedSearch}`

    return null
}

export function getRequiredKycPhonePath(user?: Pick<UserResource, 'phoneNumbers'> | null, search = ''): string | null {
    const normalizedSearch = normalizeSearch(search)
    const verifiedPhoneNumber = getVerifiedPhoneNumber(user)
    if (verifiedPhoneNumber) return null

    return `/sign-up/kyc/phone${normalizedSearch}`
}
